import { render, staticRenderFns } from "./MoveTabs.vue?vue&type=template&id=553fb437&scoped=true&"
import script from "./MoveTabs.vue?vue&type=script&lang=js&"
export * from "./MoveTabs.vue?vue&type=script&lang=js&"
import style0 from "./MoveTabs.vue?vue&type=style&index=0&id=553fb437&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553fb437",
  null
  
)

/* custom blocks */
import block0 from "./MoveTabs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports